import { FilterOption } from '#service/autocomplete-service/option';

class ApplianceStatusOptionService {
  getOptionsRaw() {
    return [
      { label: 'All', value: 'all', id: '1', default: true },
      { label: 'Active', value: '200', id: '200' },
      { label: 'Stopped', value: '300', id: '300' }
    ];
  }

  async fetchOptionsRaw(value, fetchOptions, ids) {
    const options = this.getOptionsRaw();

    if (ids) {
      return options.filter(o => o.value === ids);
    }

    return options;
  }

  async getOptions(value, fetchOptions, ids) {
    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions, ids);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options.map(option => {
      const label = `${option.label}`;
      return new FilterOption(option, label);
    });
  }
}

export default ApplianceStatusOptionService;
